import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import Usuarios from '../../../components/auth/usuarios'


function UsuariosScreen() {

    return (
        <Fragment>
            <Head titulo="Fiscais da Transparência" />
            <HeaderLogged />
            <Container>
               <Usuarios />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default UsuariosScreen;